import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./ViewBook.module.css";
import BookInfo from "../BookModule.module.css";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  CurrencyRupee,
  HeartBrokenSharp,
  HeartBrokenTwoTone,
} from "@mui/icons-material";
import { Favorite, Star } from "@material-ui/icons";
import DeafultImage from "../Default.jpg";
// import PdfImage from "../pdf.png";
import pdfImage from "../pdf.png";
import { Modal } from "react-bootstrap";
import { Rating } from "@mui/material";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../../labels";
import { UserContext } from "../../../../../context/UserDetails";
import moment from "moment";
import { AxiosInstance } from "../../../../../axios";
import toast from "react-hot-toast";
import CardTemplate from "../CardTemplate";
import PreOrderNote from "../PreOrderNote";
import Loader from "../../../Loader";
import PaginationTop10 from "../../../../../pages/dashboard/PaginationTop10";
import { CartContext } from "../../../../../context/CartItems";
import { WishListContext } from "../../../../../context/WishListItems";
import avatarImg from "./avatarimg.png";
import Select, { components } from "react-select";
import { customStyles } from "../../../../../pages/customStyles";
import fileDownload from "js-file-download";
import axios from "axios";
export default function ViewBook() {
  const location = useLocation();
  // const { isds } = location.state || {};
  const { id } = useParams();
  const imageRef = useRef(null);
  const ratingSectionRef = useRef(null);
  const [flagReload, setFlagReload] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [id]);

  useEffect(() => {
    findByidBook(id);
  }, [id, flagReload]);

  useEffect(() => {
    if (id) {
      findByidBook(id);
      window.scrollTo(0, 0);
    }

    const handleRefresh = () => {
      console.log("refreshPage event triggered");
      if (id) {
        findByidBook(id);
        window.scrollTo(0, 0);
      }
    };

    window.addEventListener("refreshPage", handleRefresh);

    return () => {
      window.removeEventListener("refreshPage", handleRefresh);
    };
  }, [id]);

  let BooksPerPageforWidgets = 4;
  const [bookData, setBookData] = useState([]);

  const [booksetData, setBooksetData] = useState([]);
  const [preOrderbooksetData, setPreOrderbooksetData] = useState([]);
  const [simliarBookData, setSimliarBookData] = useState([]);
  const [ratingsData, setRatingsData] = useState([]);
  const { cartNotify } = useContext(CartContext);
  const { WishNotify } = useContext(WishListContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false); // To control when the slideshow starts
  const [initialfields, setInitialfields] = useState({
    ratingStar: 0,
    rateBook: "",
    iframe: "",
  });
  let page = R_PER_PAGE;
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }
  const [booksetIndex, setBooksetIndex] = useState(0);
  const [similarbooksetIndex, setSimilarbooksetIndex] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState({});
  const [open, setOpen] = useState(false);
  const [isAddedToCart, setIsAddedToCart] = useState(
    bookData.is_cartlist === 1
  );
  const [popu_on, setPopu_on] = useState([]);
  const [poPularity, setPoPularity] = useState([
    {
      value: "0",
      label: "Ratings : High to Low",
    },
    {
      value: "1",
      label: "Ratings : Low to High",
    },
    {
      value: "2",
      label: "Date - Recent to Old",
    },
    {
      value: "3",
      label: "Date - Old to Recent",
    },
  ]);
  // view book details
  // Fetch review API
  const fetchReviews = () => {
    let tempPopu = popu_on.map((obj) => Number(obj.id));
    const reviewData = {
      id: id,
      rating: popu_on.length > 0 ? tempPopu[0] : 0,
    };

    setIsLoading(true);
    AxiosInstance.post("/api/book/reviews", reviewData)
      .then((res) => {
        if (res.data.status) {
          console.log(res.data.data, "Reviews loaded");
          setRatingsData(res.data.data);
        }
      })
      .catch((error) => {
        sessionStorage.clear();
        navigate("/login");
        console.error("Error loading reviews", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Call on mount or popu_on change
  useEffect(() => {
    fetchReviews();
  }, [id, popu_on]);

  // Call on refresh event
  useEffect(() => {
    const handleRefresh = () => {
      console.log("refreshPage for reviews");
      fetchReviews();
    };

    window.addEventListener("refreshPage", handleRefresh);
    return () => {
      window.removeEventListener("refreshPage", handleRefresh);
    };
  }, []);

  const findByidBook = (booksd_id) => {
    const DAT = {
      id: parseInt(booksd_id),
      author_id: "",
      publisher_id: "",
      category_id: "",
      group_course_id: "",
      subject_id: "",
      medium: "",
      visible_user: "",
      user_type: 2, // default 2 means student side
      user_id: userid,
    };

    setIsLoading(true); //Start loader

    AxiosInstance.post("/api/book/findById", DAT)
      .then((res) => {
        if (res.data.status) {
          const BookDetail = res?.data?.data;
          const BooksetDetails = res?.data?.set_book;
          const PreOrderBooksetDetails =
            BooksetDetails?.length > 0
              ? BooksetDetails.filter((io) => io.is_pre_order === 1)
              : [];
          const similarBook = res?.data?.similarBook;

          setBookData(BookDetail);
          setBooksetData(BooksetDetails);
          setPreOrderbooksetData(PreOrderBooksetDetails);
          setSimliarBookData(similarBook);
        } else {
          console.warn("Book data not found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching book:", error);
      })
      .finally(() => {
        setIsLoading(false); // Stop loader after success or error
      });
  };

  // dot slider
  const images =
    bookData?.images?.length > 0
      ? bookData?.images?.map((op) => `${ImageUrlPrefix}/${op.book_image_path}`)
      : bookData.is_ebook == 1
      ? [pdfImage]
      : [DeafultImage];

  useEffect(() => {
    let interval;

    // Start the slideshow only when hovered
    if (isHovered) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 2000); // Slide changes every 3 seconds
    }

    return () => {
      clearInterval(interval); // Clear the interval when unhovered or component unmounts
    };
  }, [isHovered, images.length]);

  const handleMouseEnter = () => {
    setIsHovered(true); // Start slideshow on hover
  };

  const handleMouseLeave = () => {
    setIsHovered(false); // Stop slideshow on hover leave
  };

  // prev button pagination
  const handlePrev_bookset = (val) => {
    if (booksetIndex > 0) {
      setBooksetIndex(booksetIndex - 1);
    }
  };
  // next button pagination
  const handleNext_bookset = (val) => {
    if (
      booksetIndex <
      Math.ceil(totalBooksetI.length / BooksPerPageforWidgets) - 1
    ) {
      setBooksetIndex(booksetIndex + 1);
    }
  };

  const handlePrev_similarbook = () => {
    if (similarbooksetIndex > 0) {
      setSimilarbooksetIndex(similarbooksetIndex - 1);
    }
  };
  const handleNext_similarbook = () => {
    if (
      similarbooksetIndex <
      Math.ceil(totalSimilarPages_top.length / BooksPerPageforWidgets) - 1
    ) {
      setSimilarbooksetIndex(similarbooksetIndex + 1);
    }
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index); // Change the current slide based on dot click
  };

  const navigateToPreviousScreen = () => {
    navigate("/studyMaterials/Books/ViewAllBook");
    // navigate(-1);
  };

  const handleIframeChange = (e) => {
    let value = e.target.value;
    let errorMessage = "";

    // ✅ Always update the input value (even when empty)
    setInitialfields((prevFields) => ({
      ...prevFields,
      iframe: value,
    }));

    // ✅ If empty, clear the error and return early
    if (value.trim() === "") {
      setError((prev) => ({
        ...prev,
        iframe: "",
      }));
      return;
    }

    // ✅ Validate only when there's a value
    const youtubeRegex =
      /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;

    if (!youtubeRegex.test(value)) {
      errorMessage = "Please enter a valid YouTube URL";
    } else {
      const youtuMatch = value.match(
        /^https?:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(\?.*)?$/
      );
      if (youtuMatch) {
        value = `https://www.youtube.com/embed/${youtuMatch[1]}`;
        // ✅ Update with embed URL if valid
        setInitialfields((prevFields) => ({
          ...prevFields,
          iframe: value,
        }));
      }
    }

    // ✅ Update the error message (empty string if valid)
    setError((prev) => ({
      ...prev,
      iframe: errorMessage,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "rateBook") {
      if (value.length <= 500) {
        setInitialfields((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));
      }
    } else {
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
    }

    setError({
      ...error,
      [name]: "",
    });
  };
  const cleanIframeUrl = (iframeString) => {
    if (!iframeString) return "";
    const match = iframeString.match(/src="([^"]*)"/);
    return match ? match[1] : iframeString; // If match found, return extracted src; otherwise, return as-is
  };
  const handleSubmit = () => {
    setOpen(true);
  };
  const handleModelClose = () => {
    setOpen(false);
    setError({
      ...error,
      ratingStar: "",
      rateBook: "",
    });
    setInitialfields((prevFields) => ({
      ratingStar: 0,
      rateBook: "",
      iframe: "",
    }));
  };
  const validateERRORDEFields = (datas) => {
    const errors = {};
    if (
      datas.ratingStar === "" ||
      datas.ratingStar === 0 ||
      datas.ratingStar === null
    ) {
      errors.ratingStar = "Please give rating ";
    }
    if (datas.rateBook.trim() === "") {
      errors.rateBook = "Please fill the review comments";
    }

    return errors;
  };
  const handleMSReview = () => {
    const errors = validateERRORDEFields(initialfields);

    if (initialfields.iframe.trim()) {
      const youtubeRegex =
        /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;

      if (
        initialfields.iframe.trim() === "<iframe></iframe>" ||
        !youtubeRegex.test(initialfields.iframe)
      ) {
        errors.iframe = "Invalid YouTube URL";
      }
    }

    if (Object.keys(errors).length === 0) {
      setIsLoading(true); //  Start loading

      const assignratingStar = {
        id: "",
        book_id: parseInt(id),
        rating: initialfields.ratingStar,
        review: initialfields.rateBook,
        video_path: initialfields.iframe.trim()
          ? cleanIframeUrl(initialfields.iframe)
          : "",
        created_dt: moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        created_by: userid,
      };

      AxiosInstance.post("/api/book/addReview", assignratingStar)
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message);
            setInitialfields({
              ratingStar: 0,
              rateBook: "",
              iframe: "",
            });
            handleModelClose();
            setFlagReload(!flagReload);

            //  Trigger page refresh
            window.dispatchEvent(new Event("refreshPage"));
          } else {
            toast.error(res.data.message);
            sessionStorage.clear();
            navigate("/login");
            setInitialfields({
              ratingStar: 0,
              rateBook: "",
              iframe: "",
            });
            handleModelClose();
            setFlagReload(!flagReload);

            //  Trigger page refresh
            window.dispatchEvent(new Event("refreshPage"));
          }
        })
        .catch((error) => {
          console.error("Error submitting review:", error);
          toast.error("Failed to submit review");
        })
        .finally(() => {
          setIsLoading(false); //  End loading
        });
    } else {
      setError(errors);
    }
  };

  const totalPages = Math.ceil(ratingsData?.length / rowsPerPage);
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    // setUpdateListData([]);
    // loadListdata();
  };

  const handleRating = (newValue) => {
    setInitialfields((prevFields) => ({
      ...prevFields,
      ["ratingStar"]: newValue,
    }));
    setError({
      ...error,
      ["ratingStar"]: "",
    });
  };

  // add to cart function
  const handleCartPage = (idss) => {
    AxiosInstance.post("/api/book/cart/add", {
      id: "",
      user_id: userid,
      book_id: idss,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          setFlagReload((prev) => !prev);
          cartNotify(userid);
        } else {
          toast.error(res.data.message);
          sessionStorage.clear();
          navigate("/login");
          setFlagReload((prev) => !prev);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const addWishList = (idsBook, is_fav) => {
    AxiosInstance.post("api/book/wishlist/add", {
      user_id: userid,
      book_id: idsBook,
      is_favorite: is_fav == 1 ? 0 : 1,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          setFlagReload(!flagReload);
          WishNotify(userid);
        } else {
          toast.error(res.data.message);
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((error) => {
        return error;
      });
  };
  // for similar books
  const totalSimilarPages_top = simliarBookData?.slice(-12);
  const similarBookD =
    totalSimilarPages_top.length > 0
      ? totalSimilarPages_top.slice(
          similarbooksetIndex * BooksPerPageforWidgets,
          (similarbooksetIndex + 1) * BooksPerPageforWidgets
        )
      : [];
  const totalBooksetI = booksetData?.slice(-12);
  const BookSetD =
    totalBooksetI.length > 0
      ? totalBooksetI.slice(
          booksetIndex * BooksPerPageforWidgets,
          (booksetIndex + 1) * BooksPerPageforWidgets
        )
      : [];
  const handlechange_popup = (option) => {
    if (option) {
      setPopu_on([
        { id: option.value, name: option.label, type: "popup_section" },
      ]);
    } else {
      setPopu_on([]);
    }

    // Scroll to Ratings and Reviews section
    if (ratingSectionRef.current) {
      ratingSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getYouTubeID = (url) => {
    if (!url || typeof url !== "string") return "";

    const regExp =
      /(?:youtube\.com\/(?:.*[?&]v=|v\/|embed\/|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };
  const handleDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${bookData.preview_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };

  const [showPopup, setShowPopup] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const handleImageClick = (src) => {
    setCurrentImage(src);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    // setCurrentImage(null);
  };

  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });

  const [hovered, setHovered] = useState(false);

  const handleMouseMove = (e) => {
    const { top, left, width, height } =
      imageRef.current.getBoundingClientRect();
    const x = ((e.pageX - left - window.scrollX) / width) * 100;
    const y = ((e.pageY - top - window.scrollY) / height) * 100;
    setZoomPosition({ x, y });
  };

  const handleTagsFilter = (id, tagName) => {
    const newTag = [{ id, name: tagName, type: "selectedTags" }];
    navigate("/studyMaterials/Books/ViewAllBook", {
      state: {
        SELECTEDTAGS: newTag,
      },
    });
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div className={`BathHeader global_container ${styles.CourseInfoSec}`}>
        <div className="row mx-0">
          <div className="col-md-6 col-12 px-0">
            <h2 className="TitleHeader">View Book</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn px-0">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to={"javascript:void(0)"}
                  onClick={navigateToPreviousScreen}
                  className="secondaryButton "
                  variant="secondary"
                >
                  Back
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* -------------------View Book Details------------- */}
        <div className="row m-0 d-flex justify-content-sm-center justify-content-lg-start">
          {/* Start column - 4 */}
          <div
            className={`${BookInfo.cardContainer} ms-0 ${styles.cardView} col-12 col-xl-4 col-lg-4 col-md-4  `}
            // style={{ maxHeight: "500px" }}
          >
            {/* 1st */}
            <div className={`row mx-0`}>
              <div className="px-0 col-md-12 d-flex ">
                <div
                  className={`col-md-6 col-6 col-xs-6 col-sm-6 ${BookInfo.dots_navigation}`}
                >
                  {/* indicators circle */}
                  <ul className="d-flex mb-0">
                    {images.map((_, index) => (
                      <li
                        key={index}
                        className={
                          currentIndex === index ? `${BookInfo.active_dot}` : ``
                        }
                        onClick={() => handleDotClick(index)}
                      ></li>
                    ))}
                  </ul>
                </div>

                <div
                  className={`col-md-6 col-6 col-xs-6 col-sm-6 d-flex flex-row justify-content-end`}
                >
                  {/* Favorite */}
                  <Favorite
                    onClick={() => addWishList(id, bookData.is_wishlist)}
                    className={
                      bookData.is_wishlist == 1
                        ? `${BookInfo.heart_wishlist_icon_active}`
                        : `${BookInfo.heart_wishlist_icon}`
                    }
                  />
                </div>
              </div>
            </div>

            {/* 2nd */}
            <div
              className={`row mx-0 padding_10_0 text-center ${BookInfo.BookborderRed}`}
              onMouseEnter={handleMouseEnter} // Pause on hover
              onMouseLeave={handleMouseLeave} // Resume on leave
            >
              <div className={`px-0 col-md-12 col-12 col-lg-12 my-3`}>
                <img
                  ref={imageRef}
                  src={images[currentIndex]}
                  alt="Book Image"
                  className={`${styles.bookImage} img-fluid`}
                  style={{ cursor: "zoom-in" }}
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                  onMouseMove={handleMouseMove}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleImageClick(images[currentIndex]);
                  }}
                />
              </div>
            </div>
            {showPopup && (
              <div className={styles.modal}>
                <span className={styles.close} onClick={handleClosePopup}>
                  &times;
                </span>
                <img
                  className={styles.modalImage}
                  src={currentImage}
                  alt="Zoomed"
                />
              </div>
            )}
            {/* tagLine */}
            <div
              className={`row mx-0 padding_10_0 text-center ${BookInfo.BookborderRed}`}
            >
              <div className={`px-0 col-md-12 col-12 col-lg-12 my-3`}>
                <span>{bookData.tag_line}</span>
              </div>
            </div>
            {/* 3rd */}
            <div className="row mx-0">
              <div
                className={`px-0 mt-2 col-xl-12 col-lg-12 col-md-12 col-12 `}
              >
                {/* <Link
                  to="javascript:void(0)"
                  onClick={
                    bookData.is_cartlist == 1 ||
                    (bookData.stock_count == 0 &&
                      bookData.is_ebook == 0 &&
                      bookData.is_set == 0) ||
                    (bookData.stock_count == 0 &&
                      bookData.availableToUser == 0 &&
                      bookData.is_set == 1)
                      ? () => {}
                      : () => handleCartPage(id)
                  }
                  className={`primaryButton text-center ${
                    BookInfo.fullWidthButton
                  } ${
                    bookData.is_cartlist == 1 ||
                    (bookData.stock_count == 0 &&
                      bookData.is_ebook == 0 &&
                      bookData.is_set == 0) ||
                    (bookData.stock_count == 0 &&
                      bookData.availableToUser == 0 &&
                      bookData.is_set == 1)
                      ? "disabled_btn"
                      : ""
                  }`}
                  variant="primary"
                >
                  Add To Cart
                </Link> */}
                <Link
                  to="javascript:void(0)"
                  onClick={() => {
                    if (bookData.is_cartlist === 1) {
                      navigate("/AddToCart");
                    } else if (
                      (bookData.is_ebook === 0 &&
                        bookData.is_set === 0 &&
                        bookData.stock_count === 0) ||
                      (bookData.availableToUser === 0 &&
                        bookData.is_set === 1 &&
                        bookData.stock_count === 0) ||
                      (bookData.is_visible === 0 && bookData.is_set === 0) ||
                      bookData.is_pre_order === 1
                    ) {
                      return;
                    } else {
                      handleCartPage(bookData.id);
                    }
                  }}
                  className={`primaryButton text-center ${
                    BookInfo.fullWidthButton
                  } ${
                    (bookData.is_ebook === 0 &&
                      bookData.is_set === 0 &&
                      bookData.stock_count === 0) ||
                    (bookData.availableToUser === 0 &&
                      bookData.is_set === 1 &&
                      bookData.stock_count === 0) ||
                    (bookData.is_visible === 0 && bookData.is_set === 0) ||
                    bookData.is_pre_order === 1
                      ? "disabled_btn"
                      : ""
                  } ${
                    isAddedToCart || bookData.is_cartlist === 1
                      ? `${BookInfo.goToCartStyle}`
                      : `${BookInfo.addToCartStyle}`
                  }`}
                  variant="primary"
                >
                  <span className={BookInfo.buttonText}>
                    {isAddedToCart || bookData.is_cartlist === 1
                      ? "Go to Cart"
                      : "Add to Cart"}
                  </span>
                  <span className={BookInfo.arrowIcon}>&rarr;</span>
                </Link>
              </div>
            </div>
          </div>
          {/**/}
          {/* Start column - 7 */}

          <div
            className={`${BookInfo.cardContainer}  ${styles.width_set}  ms-2 ${styles.cardView} col-12 col-xl-7 col-lg-7 col-md-7  `}
          >
            {hovered ? (
              <div
                style={{
                  overflow: "hidden",
                  width: "800px",
                  height: "450px",
                  border: "1px solid #ccc",
                  margin: "auto",
                }}
              >
                <img
                  src={images[currentIndex]}
                  alt="Zoomed"
                  style={{
                    transform: "scale(2)",
                    transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`,
                    transition: "transform 0.1s ease",
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    pointerEvents: "none",
                  }}
                />
              </div>
            ) : (
              <div className="text-muted">
                <div>
                  {/* 1st */}
                  <div
                    className={`row mx-0 padding_10_0 ${BookInfo.BookborderRed}`}
                  >
                    <div className="px-0 col-md-12">
                      <p
                        className={`${BookInfo.ellipsis_book} text-start ${styles.BookTitle} mb-1`}
                      >
                        {bookData.is_set == 1
                          ? `${bookData.book_title} (Set of ${bookData.no_of_books} Books)`
                          : `${bookData.book_title}`}
                      </p>
                      <p
                        className={`mb-0 ${styles.BookSubTitle} ${BookInfo.ellipsis_book} opacity-100 text-start mb-1`}
                      >
                        {bookData.author}
                      </p>
                      <p
                        className={`mb-0 ${BookInfo.BookSubTitle} ${BookInfo.ellipsis_book} text-start mb-1`}
                      >
                        {bookData.publisher}
                      </p>
                      {bookData.purchase_count > 0 && (
                        <p
                          className={`${styles.PurchasedTitle} ${BookInfo.ellipsis_book} text-start mb-0`}
                        >
                          {`Purchased by ${
                            bookData.purchase_count
                              ? bookData.purchase_count
                              : 0
                          } exam aspirants - and counting!`}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* ---2 border ----*/}
                  <div
                    className={`row mx-0 padding_10_0 ${BookInfo.BookborderRed}`}
                  >
                    <div className="px-0 col-md-12 d-flex flex-wrap justify-content-left">
                      {/* Left Column */}
                      <div
                        className={`col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 text-left`}
                      >
                        <p className={`mb-0`}>
                          <span className={BookInfo.item_price}>
                            <CurrencyRupee className={BookInfo.rupees_icon} />
                            {bookData.finalPrice}
                          </span>

                          {bookData.offer_percentage > 0 && (
                            <>
                              <span className={BookInfo.item_price_disAmount}>
                                {" "}
                                {bookData.price}
                              </span>
                              <span className={BookInfo.item_price_offer}>
                                {" "}
                                {bookData.offer_percentage}% off
                              </span>
                            </>
                          )}
                        </p>
                      </div>
                      {/* Right Column */}

                      {/* {bookData.is_ebook == 0 && ()} */}
                      <div
                        className={`col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 text-center W-50`}
                      >
                        {bookData.is_ebook === 1 ? (
                          <p
                            className={`${BookInfo.stock_item_right_label} mb-0`}
                          >
                            E-Book
                          </p>
                        ) : bookData.stock_count === 0 &&
                          bookData.is_set == 0 ? (
                          <p
                            className={`${BookInfo.stock_item_right_label} mb-0`}
                          >
                            Out of Stock
                          </p>
                        ) : bookData.stock_count > 0 &&
                          bookData.stock_count < 10 &&
                          bookData.is_set == 0 ? (
                          <p
                            className={`${BookInfo.stock_item_right_label} mb-0`}
                          >
                            {`Only ${bookData.stock_count} ${
                              bookData.stock_count > 1 ? `books` : `book`
                            } left`}
                          </p>
                        ) : bookData.is_set == 1 &&
                          bookData.is_pre_order == 1 ? (
                          <p
                            className={`${BookInfo.stock_item_right_label} mb-0`}
                          >
                            Pre-order
                          </p>
                        ) : bookData.stock_count === 0 &&
                          bookData.is_set == 1 &&
                          bookData.availableToUser == 0 ? (
                          <p
                            className={`${BookInfo.stock_item_right_label} mb-0`}
                          >
                            Out of Stock
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  {/* ----3 Border ----*/}
                  {bookData.overall_ratings > 0 && ratingsData?.length > 0 && (
                    <div
                      className={`row mx-0 padding_10_0 ${BookInfo.BookborderRed}`}
                    >
                      <div className="px-0 col-md-12 d-flex flex-wrap justify-content-left align-items-center text-center">
                        {/* Left Column */}
                        <div
                          className={`${BookInfo.ratings_star_icon} mb-2 mb-md-0`}
                        >
                          <p className={`${BookInfo.rating_title} mb-0`}>
                            {bookData.overall_ratings}
                            <Star className={BookInfo.star_icon} />
                          </p>
                        </div>

                        {/* Right Column */}
                        <div className="text-center W-100">
                          <p
                            className={`mb-0 ${BookInfo.BookSubTitle} text-start`}
                          >
                            {`(based on ${bookData.no_of_students} ratings and reviews given by our students)`}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* ----4 border---- */}
                  <div
                    className={`row mx-0 padding_10_0 ${BookInfo.BookborderRed}`}
                  >
                    <div className="px-0 col-md-12 d-flex flex-wrap justify-content-left">
                      <p
                        className={`mb-0 ${BookInfo.BookSubTitle} opacity-75 text-start mb-1`}
                      >
                        {bookData.description}
                      </p>
                    </div>
                  </div>
                  {/* --- 5 border ----*/}
                  <div
                    className={`row mx-0  ${
                      (bookData.category_name
                        ? "padding_10_0"
                        : "" || bookData.group_course_name
                        ? "padding_10_0"
                        : "" || bookData.subject_name
                        ? "padding_10_0"
                        : "" || bookData.medium
                        ? "padding_10_0"
                        : "") && BookInfo.BookborderRed
                    }`}
                  >
                    {bookData.category_name && (
                      <div className="my-1 col-lg-3 col-md-3 col-12 padding-right-left-6">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Category</p>
                          <p
                            className="confirm_value my-1 m-0 "
                            style={{ paddingRight: "5px" }}
                          >
                            {bookData.category_name}
                          </p>
                        </div>
                      </div>
                    )}
                    {bookData.group_course_name && (
                      <div className="my-1 col-lg-3 col-md-3 col-12 padding-right-left-6">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Course</p>
                          <p className="confirm_value my-1 m-0 ">
                            {bookData.group_course_name}
                          </p>
                        </div>
                      </div>
                    )}
                    {bookData.subject_name && (
                      <div className="my-1 col-lg-3 col-md-3 col-12 padding-right-left-6">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Subject</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {bookData.subject_name}
                          </p>
                        </div>
                      </div>
                    )}

                    {bookData.medium && (
                      <div className="my-1 col-lg-3 col-md-3 col-12 padding-right-left-6">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Medium</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {bookData.medium}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* 6 */}
                  <div
                    className={`row  mx-0 padding_10_0 ${BookInfo.BookborderRed}`}
                  >
                    <div className="px-0 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Tags</p>
                        <ul
                          className={` p-0 m-0 d-flex flex-wrap mt-1 ${BookInfo.BookTagchip}`}
                        >
                          {bookData?.tags?.length > 0 && (
                            <>
                              {bookData?.tags?.slice(0, 8).map((op, index) => (
                                <li key={index}>
                                  <a
                                    // style={{ cursor: "default" }}
                                    href="javascript:void(0)"
                                    className={BookInfo.BookTagChipLabel}
                                    title={op.tag_name}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleTagsFilter(op.tag_id, op.tag_name);
                                    }}
                                  >
                                    {op.tag_name}
                                  </a>
                                </li>
                              ))}
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* --- 7 border ----*/}

                  {bookData.is_set == 0 ? (
                    <div
                      className={`row mx-0 padding_10_0 ${BookInfo.BookborderRed}`}
                    >
                      {bookData.is_ebook !== 1 && (
                        <>
                          <div className="my-1 px-0 col-lg-3 col-md-3 col-12">
                            <div className="d-flex flex-column">
                              <p className="confirm_label m-0 p-0">Dimension</p>
                              <p className="confirm_value my-1 m-0 p-0">
                                {bookData.dimension} CM
                              </p>
                            </div>
                          </div>

                          <div className="my-1 px-0 col-lg-3 col-md-3 col-12">
                            <div className="d-flex flex-column">
                              <p className="confirm_label m-0 p-0">Weight</p>
                              <p className="confirm_value my-1 m-0 p-0">
                                {bookData.weight} KG
                              </p>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="my-1 px-0 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Total Pages</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {bookData.total_pages}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={`row mx-0 padding_10_0 `}>
                      <div className="my-1 px-0 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Weight</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {bookData.weight} KG
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                  {console.log(bookData.preview_path, "1234567")}
                  {/* 8 */}
                  {bookData.is_set == 0 && bookData.preview_path && (
                    <div className={`row mx-0 padding_10_0`}>
                      <div className="px-0 col-12">
                        <label className="confirm_label m-0 p-0">
                          Sample Pages
                        </label>
                        {/* {io.descriptive_answer_sheet !== null && ( */}
                        <a
                          to="javascript:void(0)"
                          onClick={() =>
                            handleDownload(
                              bookData.original_preview_path,
                              bookData.original_preview_path
                            )
                          }
                        >
                          <span
                            className={`${styles.mui_icon} material-icons align-middle mx-1`}
                          >
                            file_download
                          </span>
                        </a>
                        {/* )} */}
                        <p className="confirm_value my-1 m-0 p-0">
                          {" "}
                          {bookData.original_preview_path}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* -------------------Inside the Books------------- */}

        <div className="row m-0">
          {bookData.is_set == 0 && bookData?.iframe && (
            <fieldset className="mt-3">
              <legend className="w-auto">Inside the Book</legend>
              <div className="row">
                <div className="my-1 col-lg-12 col-md-12 col-12 text-center">
                  <iframe
                    src={`https://www.youtube.com/embed/${getYouTubeID(
                      bookData.iframe
                    )}`}
                    className={`${styles.iframeVideo}`}
                    allowFullScreen
                    title="Dynamic Iframe"
                  ></iframe>
                </div>
              </div>
            </fieldset>
          )}
          {bookData.is_set == 1 && preOrderbooksetData.length > 0 && (
            <div className="col-md-12 mt-3 col-lg-12 col-12 px-0">
              <PreOrderNote preOrderdata={preOrderbooksetData} />
            </div>
          )}

          {bookData.is_set == 1 && BookSetD.length > 0 && (
            <fieldset className="mt-3">
              <legend className="w-auto">Books in this Set</legend>
              <div className="row">
                {BookSetD?.map((er) => (
                  <div className="my-1 col-lg-3 col-md-3 col-12 text-center">
                    <CardTemplate
                      items={er}
                      toggleWish={addWishList}
                      handleSubmitCart={() => handleCartPage(er.id)}
                      tagsFilter
                      handleViewFilter
                      isSet={1}
                    />
                  </div>
                ))}
              </div>
              <PaginationTop10
                totCount={Array.from({
                  length: Math.ceil(
                    totalBooksetI.length / BooksPerPageforWidgets
                  ),
                })}
                currentPage={booksetIndex}
                onPageChange={setBooksetIndex}
                hPrev={handlePrev_bookset}
                hNext={handleNext_bookset}
              />
            </fieldset>
          )}

          {/*  Similar Books for Your Study */}
          {similarBookD.length > 0 && (
            <fieldset className="mt-3">
              <legend className="w-auto">Similar Books for Your Study</legend>
              <div className="row">
                {similarBookD.map((er) => (
                  <div className="my-1 col-lg-3 col-md-3 col-12 text-center">
                    <CardTemplate
                      items={er}
                      toggleWish={addWishList}
                      handleSubmitCart={() => handleCartPage(er.id)}
                    />
                  </div>
                ))}
              </div>
              {showPopup && (
                <div className={styles.modal}>
                  <span className={styles.close} onClick={handleClosePopup}>
                    &times;
                  </span>
                  <img
                    className={styles.modalImage}
                    src={currentImage}
                    alt="Zoomed"
                  />
                </div>
              )}
              <PaginationTop10
                totCount={Array.from({
                  length: Math.ceil(
                    totalSimilarPages_top?.length / BooksPerPageforWidgets
                  ),
                })}
                currentPage={similarbooksetIndex}
                onPageChange={setSimilarbooksetIndex}
                hPrev={handlePrev_similarbook}
                hNext={handleNext_similarbook}
              />
            </fieldset>
          )}
          <fieldset className="mt-3" ref={ratingSectionRef}>
            <legend className="w-auto">Ratings and Reviews</legend>
            <div className="  mt-2">
              <div
                className={`${styles.mobileRatings} ulFilterListData d-flex`}
              >
                <div className="filterListData col-md-6 col-12">
                  {bookData?.overall_ratings > 0 && (
                    <div
                      className={`${BookInfo.ratings_star_icon} mb-2 mb-md-0`}
                    >
                      <p className={`${BookInfo.rating_title} mb-0`}>
                        {bookData?.overall_ratings}
                        <Star className={BookInfo.star_icon} />
                      </p>
                    </div>
                  )}
                  {ratingsData?.length > 0 && (
                    <p className={`mb-0 ${BookInfo.BookSubTitle} text-start`}>
                      {`(based on ${bookData?.no_of_students} ratings and reviews given by our students)`}
                    </p>
                  )}
                </div>

                <div
                  class={` ${styles.editAddress} ListBtnItems col-md-6 col-12`}
                >
                  <Select
                    className={`shadow-none input-font-size mt-1 ${styles.selectWidth}`}
                    name="popup_section"
                    isClearable={true}
                    onChange={(option) =>
                      handlechange_popup(option, "popup_section")
                    }
                    value={popu_on.map((value) => ({
                      value: value.id,
                      label: value.name,
                    }))}
                    options={poPularity}
                    isSearchable={true}
                    placeholder="Sort by"
                    maxMenuHeight={200}
                    filterOption={(option, searchText) =>
                      option.label
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    }
                    styles={customStyles}
                  />

                  <ul class="List-Button ">
                    <li class="ListBtnItems">
                      <Link
                        onClick={handleSubmit}
                        to="javascript:void(0)"
                        className="primaryButton "
                      >
                        Add Review
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {ratingsData?.length > 0 ? (
              ratingsData?.map((ui) => (
                <>
                  <div className="borderWidth  mt-2">
                    <div className="row">
                      <div className="col-md-12 ">
                        <div className="d-flex mt-2">
                          <div className="">
                            {ui.profile_path ? (
                              <img
                                src={`${ImageUrlPrefix}/${ui.profile_path}`}
                                alt="Book Image"
                                className={`${styles.userProfileImage}`}
                              />
                            ) : (
                              <img
                                src={avatarImg}
                                alt="Book Image"
                                className={`${styles.userProfileImage}`}
                              />
                            )}
                          </div>
                          <div className={`${styles.userProfileName} `}>
                            <p className={`${styles.reviewUserName} m-0`}>
                              {" "}
                              {ui.username}{" "}
                              {`(${moment(ui.date).format("DD/MM/YYYY")})`}
                            </p>
                            <div className="mt-1">
                              <Rating
                                name="simple-controlled"
                                sx={{
                                  "& .MuiRating-iconFilled": {
                                    color: "#c0272d", // Set filled icon color
                                  },
                                  "& .MuiRating-iconHover": {
                                    color: "#c0272d", // Set hover color
                                  },
                                  margin: 0,
                                }}
                                value={ui.rating} // Use the rating state to control the selected stars
                                readOnly // This will stop hover interactions
                              />
                            </div>
                            <div className="col-md-12">
                              <p className={`${styles.reviewUserComment} mt-2`}>
                                {ui.review}
                              </p>
                            </div>
                            {ui.video_path && (
                              <div className="col-lg-6 col-12 offset-md-12 ">
                                <iframe
                                  src={`https://www.youtube.com/embed/${getYouTubeID(
                                    ui.video_path
                                  )}`}
                                  className={`${styles.iframe_Video}`}
                                  allowFullScreen
                                  title="Dynamic Iframe"
                                ></iframe>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))
            ) : (
              <div className="borderWidth  mt-2">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <p className={`confirm_label mt-2`}>
                      No reviews to display
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="borderWidth  mt-2">
              <div className="row mt-2">
                <Pagination
                  rowsPerPage={rowsPerPage}
                  handlePageCount={handlePageCount}
                  startPage={
                    ratingsData && ratingsData?.length > 0
                      ? currentPage * rowsPerPage + 1 - rowsPerPage
                      : 0
                  }
                  endPage={
                    ratingsData && ratingsData?.length > 0
                      ? ratingsData?.length < currentPage * rowsPerPage
                        ? ratingsData?.length
                        : currentPage * rowsPerPage
                      : 0
                  }
                  totalRecords={
                    ratingsData && ratingsData?.length > 0
                      ? ratingsData?.length
                      : 0
                  }
                  handlePrev={(e) => handlePrev(currentPage - 1)}
                  currentPrevPage={currentPage === 1}
                  prevButton={`${styles.prev_buttonViewEvaluator} ${styles.materialIconsRightAndLeft} me-2`}
                  handleNext={() => handleNext(currentPage + 1)}
                  currentNextPage={
                    totalPages == 0 || currentPage === totalPages
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>

        {open && (
          <Modal
            key={`modal-0-${0}`}
            show={open}
            onHide={handleModelClose}
            size="xl"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h5
                  className={`${styles.view_title} fw-bold mb-0`}
                  id="exampleModalLabel"
                >
                  Add Rating and Review
                </h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <></>
              <div className="row global_container">
                <div className="col-12">
                  <form className="row ">
                    <div class="col-md-6">
                      <label for="ratingStar" class="form-label confirm_value ">
                        Rate this book
                      </label>
                      <div>
                        <Rating
                          name="ratingStar"
                          value={initialfields.ratingStar} // Use the rating state to control the selected stars
                          onChange={(event, newValue) => handleRating(newValue)} // Update the state on change
                          sx={{
                            "& .MuiRating-iconFilled": {
                              color: "#c0272d", // Set filled icon color
                            },
                            "& .MuiRating-iconHover": {
                              color: "#c0272d", // Set hover color
                            },
                            margin: 0,
                          }}
                        />
                      </div>
                      {error.ratingStar && (
                        <small className="error_message">
                          {error.ratingStar}
                        </small>
                      )}
                    </div>

                    <div class="col-md-6">
                      <label for="iframe" class="form-label confirm_value ">
                        Review our book (YouTube Video URL)
                      </label>

                      <input
                        className="desc_input_text w-100 rounded-2 input-font-size-sm"
                        type="text"
                        id="iframe"
                        name="iframe"
                        placeholder="Enter YouTube video URL"
                        value={initialfields.iframe || ""}
                        onChange={handleIframeChange}
                      />
                      {error.iframe && (
                        <small className="error_message">{error.iframe}</small>
                      )}
                    </div>

                    <div className="col-md-12">
                      <label for="rateBook" class="form-label confirm_value ">
                        Review this book
                      </label>
                      <textarea
                        // ref={subject_ref}
                        className={`${styles.desc_input} w-100 rounded p-2 input-font-size`}
                        placeholder="Enter the review (maximum 500 characters allowed)"
                        id="rateBook"
                        onChange={(e) => handleChange(e)}
                        value={initialfields.rateBook}
                        name="rateBook"
                        // maxLength={500}
                        style={{
                          height: "auto",
                          resize: "none",
                          // minHeight: "calc(24px * 8)",
                        }}
                      ></textarea>
                      {error.rateBook && (
                        <small className="error_message">
                          {error.rateBook}
                        </small>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <ul className="List-Button">
                <li className="ListBtnItems">
                  <Link onClick={handleModelClose} className="secondaryButton">
                    Back to View Book
                  </Link>
                </li>
                <li className="ListBtnItems">
                  <Link onClick={handleMSReview} className="primaryButton">
                    Submit Rating & Review
                  </Link>
                </li>
              </ul>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  );
}
